import { render, staticRenderFns } from "./AddNode12.vue?vue&type=template&id=3986d68a"
import script from "./AddNode12.vue?vue&type=script&lang=js"
export * from "./AddNode12.vue?vue&type=script&lang=js"
import style0 from "./AddNode12.vue?vue&type=style&index=0&id=3986d68a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports